const enforceHttpsInSecureBrowser = (url: string) => {
  if (typeof window !== "undefined" && window.location.protocol === "https:") {
    return url.replace(/^http:\/\//i, "https://");
  }

  return url;
};

export const getApiBaseUrl = () => {
  if (process.env.NEXT_PUBLIC_API_URL) {
    return enforceHttpsInSecureBrowser(process.env.NEXT_PUBLIC_API_URL);
  }

  if (typeof window !== "undefined") {
    return `${window.location.protocol}//${window.location.hostname}:3088/api/v1`;
  }

  return "http://localhost:3088/api/v1";
};

export const getAuthToken = (): string | null => {
  if (typeof window !== "undefined") {
    return localStorage.getItem("token");
  }
  return null;
};

export const setAuthToken = (token: string | null) => {
  if (typeof window !== "undefined") {
    if (token) {
      localStorage.setItem("token", token);
      // Set token cookie so backend and Next.js can read it if needed
      document.cookie = `token=${token}; path=/; max-age=${30 * 24 * 60 * 60}; SameSite=Lax`;
    } else {
      localStorage.removeItem("token");
      document.cookie = "token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  }
};

export async function apiRequest<T = any>(
  endpoint: string,
  options: RequestInit = {}
): Promise<T> {
  const token = getAuthToken();
  
  const headers = new Headers(options.headers);
  if (token) {
    // The backend auth middleware expects the raw token in the Authorization header
    headers.set("Authorization", token);
  }
  
  if (!(options.body instanceof FormData) && !headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  const config: RequestInit = {
    cache: "no-store",
    ...options,
    headers,
  };

  const response = await fetch(`${getApiBaseUrl()}${endpoint}`, config);
  const text = await response.text();
  
  let data: any = {};
  if (text) {
    try {
      data = JSON.parse(text);
    } catch (e) {
      data = { message: text };
    }
  }

  if (!response.ok) {
    throw new Error(data.message || data.error?.message || "Something went wrong");
  }

  return data;
}
